import Modal from 'components/Modal';
import React from 'react';
import { useHistory } from 'react-router-dom';
import IntlHelper from 'utils/helpers/intl.helper';

const BackModal = () => {
  const t = IntlHelper.useTranslator();
  const history = useHistory();

  return (
    <>
      <Modal.Header title={t('vuoi_uscire')} />
      <Modal.Footer confirmText={t('continua')} confirmAction={history.goBack} withCloseButton />
    </>
  );
};

export default BackModal;
